import React, { useState, useEffect, useCallback, useRef, useContext, useReducer } from 'react';
import {
    Divider,
    Header,
    Icon,
    Table,
    List,
    Grid,
    Container,
    Button,
    Segment,
    // Dropdown,
} from 'semantic-ui-react';
import FilterModal from './FilterModal';
import './styles.scss';
import { fetch } from 'services/http';
import MaskedInput from 'react-text-mask';
import { DateTime } from 'luxon';
import history from 'services/history';
import { ProfileModal } from './ProfileModal';
import { ConfCuponsStateContext, ConfCuponsDispatchContext } from './ConfCuponsContext';
import _ from 'lodash';

function sortReducer(state, action) {
    switch (action.type) {
        case 'SET_DATA':
            return { ...state, data: action.payload };

        case 'CHANGE_SORT':
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.reverse(),
                    direction:
                        state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }

            return {
                column: action.column,
                data: action.column === 'status' ? state.data.sort((a, b) => a.as === a.control_docs ? -1 : 1 ?? 0) : _.sortBy(state.data, [action.column]),
                direction: 'ascending',
            }
        default:
            throw new Error()
    }
}

export function Dashboard() {
    const state = useContext(ConfCuponsStateContext);
    const dispatch = useContext(ConfCuponsDispatchContext);
    const [loading, setLoading] = useState(true);
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [filter, setFilter] = useState(null);
    const [dateStart, setDateStart] = useState(
        DateTime.local().weekday === 1
            ? DateTime.local().minus({ days: 3 }).toFormat('dd/MM/yyyy')
            : DateTime.local().minus({ day: 1 }).toFormat('dd/MM/yyyy'),
    );
    const [dateEnd, setDateEnd] = useState(
        DateTime.local().minus({ day: 1 }).toFormat('dd/MM/yyyy'),
    );
    const profileModalRef = useRef(null);

    const [sortState, sortDispatch] = useReducer(sortReducer, {
        column: null,
        data: [],
        direction: null,
    });
    const { column, data, direction } = sortState;

    useEffect(() => {
        (async () => {
            if (!state.profile) {
                const result = await (await fetch('/control-docs/profile')).json();
                dispatch({ type: 'UPDATE_PROFILE', payload: result.profile });
                dispatch({ type: 'UPDATE_PROFILE_STATUS', payload: result.active });

                const params = {
                    date_start:
                        DateTime.local().weekday === 1
                            ? DateTime.local().minus({ days: 3 }).toISODate()
                            : DateTime.local().minus({ day: 1 }).toISODate(),
                    date_end: DateTime.local().minus({ day: 1 }).toISODate(),
                };

                if (result.profile && result.active) {
                    params.profile = result.profile;
                }
                const response = await (
                    await fetch(`/control-docs/resume`, {
                        method: 'POST',
                        body: JSON.stringify(params),
                        headers: { 'Content-Type': 'application/json' },
                    })
                ).json();
                sortDispatch({ type: 'SET_DATA', payload: response });
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {
        if (state.profile) {
            const start = DateTime.fromFormat(dateStart, 'dd/MM/yyyy').toISODate();
            const end = DateTime.fromFormat(dateEnd, 'dd/MM/yyyy').toISODate();
            const params = {
                date_start: start,
                date_end: end,
            };
            if (state.profile) {
                params.profile = state.profile;
            }

            fetch(`/control-docs/resume`, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: { 'Content-Type': 'application/json' },
            })
                .then(res => res.json())
                .then(res => {
                    sortDispatch({ type: 'SET_DATA', payload: res });
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.profile]);

    const handleCompaniesPeriod = async () => {
        const start = DateTime.fromFormat(dateStart, 'dd/MM/yyyy').toISODate();
        const end = DateTime.fromFormat(dateEnd, 'dd/MM/yyyy').toISODate();
        const params = {
            date_start: start,
            date_end: end,
        };
        if (state.profile) {
            params.profile = state.profile;
        }

        const response = await (
            await fetch(`/control-docs/resume`, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        ).json();
        sortDispatch({ type: 'SET_DATA', payload: response });
    };

    const handleRowClicked = useCallback(
        (data) => {
            return () => {
                const start = DateTime.fromFormat(dateStart, 'dd/MM/yyyy').toISODate();
                const end = DateTime.fromFormat(dateEnd, 'dd/MM/yyyy').toISODate();

                history.push({
                    pathname: 'conferencia-de-cupons/detalhes',
                    search: `?unidade=${
                        data.unidade_id
                        }&data_cupom=${start},${end}&forma_pgto=${data.payment_types.join()}`,
                });
            };
        },
        [dateEnd, dateStart],
    );

    

    return (
        <>
            <FilterModal
                open={filterModalOpen}
                onClose={() => setFilterModalOpen(false)}
            />
            <ProfileModal
                // onClose={() => setProfileModalOpen(false)}
                ref={profileModalRef}
            />
            <Container id="conferencia-cupons" fluid>
                <Grid>
                    <Grid.Row style={{ paddingBottom: 0, marginTop: 14 }}>
                        <Grid.Column width={16}>
                            <Button type="button" primary onClick={() => setFilterModalOpen(true)}>
                                <Icon name="filter" /> Filtrar
                            </Button>

                            <Button
                                type="button"
                                color="green"
                                onClick={() => profileModalRef.current?.open()}
                            >
                                <Icon name="configure" /> Configurar Perfil
                            </Button>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Divider id="divider-resumo" horizontal>
                                <Header as="h4">
                                    <Icon name="building outline" />
                                    Unidade
                                </Header>
                            </Divider>
                            <Segment>
                                <List>
                                    <List.Item>
                                        <List.Icon
                                            name="calendar"
                                            style={{ paddingLeft: 0, verticalAlign: 'middle' }}
                                        />
                                        <List.Content className="companies-resume-period">
                                            <MaskedInput
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    '/',
                                                    /\d/,
                                                    /\d/,
                                                    '/',
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                                value={dateStart}
                                                onChange={(event) =>
                                                    setDateStart(event.target.value)
                                                }
                                                name="periodo_ini"
                                                showMask={true}
                                            />
                                            <MaskedInput
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    '/',
                                                    /\d/,
                                                    /\d/,
                                                    '/',
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                                value={dateEnd}
                                                onChange={(event) => setDateEnd(event.target.value)}
                                                name="periodo_fim"
                                                showMask={true}
                                            />
                                            <Button
                                                size="mini"
                                                content={<Icon name="filter" />}
                                                onClick={handleCompaniesPeriod}
                                            />
                                        </List.Content>
                                    </List.Item>
                                    <List.Item>
                                        <List.Icon name="search" style={{ paddingLeft: 0, verticalAlign: 'middle' }} />
                                        <List.Content>
                                            <input
                                                name="search-company"
                                                id="search-company"
                                                onChange={(event) => setFilter(event.target.value)}
                                            />
                                        </List.Content>
                                    </List.Item>
                                </List>
                            </Segment>
                            <div className="scrollable">
                                <Table selectable celled sortable>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell
                                                onClick={() => sortDispatch({ type: 'CHANGE_SORT', column: 'unidade_nome' })}
                                                sorted={column === 'unidade_nome' ? direction : null}
                                            >Unidade</Table.HeaderCell>
                                            <Table.HeaderCell
                                                textAlign="center"
                                                onClick={() => sortDispatch({ type: 'CHANGE_SORT', column: 'as' })}
                                                sorted={column === 'as' ? direction : null}
                                            >
                                                A.S / Control Docs
                                            </Table.HeaderCell>
                                            <Table.HeaderCell
                                                textAlign="center"
                                                onClick={() => sortDispatch({ type: 'CHANGE_SORT', column: 'status' })}
                                                sorted={column === 'status' ? direction : null}
                                            >
                                                Status
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {(() => {
                                            if (loading && !data) {
                                                return (
                                                    <Table.Row>
                                                        <Table.Cell colSpan={3}>
                                                            Carregando...
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            }

                                            if (!loading && data.length === 0) {
                                                return (
                                                    <Table.Row>
                                                        <Table.Cell colSpan={3}>
                                                            Não há dados para exibir.
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            }

                                            return data
                                                .filter((it) =>
                                                    filter ? String(it.unidade_nome).toLowerCase().indexOf(filter) !== -1 : true
                                                )
                                                .map((it, i) => (
                                                    <Table.Row
                                                        onClick={handleRowClicked(it)}
                                                        key={i}
                                                    >
                                                        <Table.Cell>{it.unidade_nome}</Table.Cell>
                                                        <Table.Cell textAlign="center">
                                                            {it.as} / {it.control_docs}
                                                        </Table.Cell>
                                                        <Table.Cell textAlign="center">
                                                            {(() => {
                                                                const status =
                                                                    it.as === it.control_docs
                                                                        ? 'success'
                                                                        : it.as > it.control_docs
                                                                            ? 'error'
                                                                            : 'warning';
                                                                switch (status) {
                                                                    case 'success':
                                                                        return (
                                                                            <Icon
                                                                                name="check"
                                                                                color="green"
                                                                            />
                                                                        );

                                                                    case 'warning':
                                                                        return (
                                                                            <Icon
                                                                                name="warning sign"
                                                                                color="yellow"
                                                                            />
                                                                        );

                                                                    case 'error':
                                                                        return (
                                                                            <Icon
                                                                                name="remove"
                                                                                color="red"
                                                                            />
                                                                        );

                                                                    default:
                                                                        return null;
                                                                }
                                                            })()}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                ));
                                        })()}
                                    </Table.Body>
                                </Table>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Divider id="divider-resumo" horizontal>
                                <Header as="h4">
                                    <Icon name="calendar outline" />
                                    Geral
                                </Header>
                            </Divider>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </>
    );
}
